import { render, staticRenderFns } from "./newAnalytics.vue?vue&type=template&id=b3162842"
import script from "./newAnalytics.vue?vue&type=script&lang=js"
export * from "./newAnalytics.vue?vue&type=script&lang=js"
import style0 from "./newAnalytics.vue?vue&type=style&index=0&id=b3162842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports